






import click2Top from "@/common/directives/click2Top";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "QFooter",
  directives: {
    click2Top,
  },
})
export default class QFooter extends Vue {}
